<div>
  <app-alert-banner></app-alert-banner>
  <main class="container subpage">
    <router-outlet>
    </router-outlet>
  </main>
</div>
